import { assetUrl } from '../config/appConfig'
import { PhoneConversation } from './PhoneConversation'
import type { SceneTimeline } from './types'

/**
 * PHONE THREAD AUTHORING
 *
 * Add groups and messages here in chronological order (oldest to newest).
 * The timeline cue below chooses which received message opens with openAt(id).
 */
const elinaPhoneConversation = new PhoneConversation({
  id: 'bruce-elina-thread',
  contact: 'Elina',
  statusTime: '1:25',
  groups: [
    {
      id: 'two-weeks-ago',
      label: '2 weeks ago',
      messages: [
        {
          id: 'bruce-asks-about-skyrim',
          direction: 'sent',
          speaker: 'Bruce',
          text: 'Hey babe, have you seen the copy of my Skyrim?',
          time: '7:16 AM',
        },
        {
          id: 'elina-replies-nope',
          direction: 'received',
          speaker: 'Elina',
          text: 'Nope..',
          time: '6:11 PM',
        },
      ],
    },

    {
      id:'1-week-ago',
      label:'1 week ago',
      messages:[
        {
          id:'elina-tells-bruce',
          direction:'received',
          speaker:'Elina',
          time:'6:01 AM',
          text:`I am going to my parents for the rest of the week, they've been missing me so I thought I would spend the week with them. You take care!!`
        },
        {
          id:'bruce-repies-to-going-to-parents-thingy',
          direction:'sent',
          speaker:'Bruce',
          time:'7:12 AM',
          text:'Oh babe, I understand that. No worries, take care and say Hii.. to your parents 🙂'
        }
      ]

    },

     {
      id:'yesterday',
      label:'yesterday',
      messages:[
        {
          id:'bruce-asks-about-the-ig-post',
          direction:'sent',
          speaker:'Bruce',
          time:'12:01 AM',
          text:`Elinaaa...looks like you were busy at that family gathering, I have seen your ig posts, I wish I was there with ya'all..`
        },
        {
          id:'elina-repies-to-fam-gathering-message',
          direction:'received',
          speaker:'Elina',
          time:'6:12 AM',
          text:'Yeah...'
        },
        {
          id:'bruce-asks-about-brad',
          direction:'sent',
          speaker:'Bruce',
          time:'6:13 AM',
          text:'Who was that guy in the 3rd picture in your ig post ? I think I have seen him before somewhere...'
        },
        {
          id:'elina-repies-to-brad-question',
          direction:'received',
          speaker:'Elina',
          time:'6:16 AM',
          text:`Oh that's Brad, he's an old friend you might have seen him in my old pictures maybe. Nothing to worry about.`
        },
        {
          id:'elina-rushes-away',
          direction:'received',
          speaker:'Elina',
          time:'6:16 AM',
          text:`Oooky Brad, I gotta go..ttyl`
        },
        {
          id:'brad-responds-to-her-typo',
          direction:'sent',
          speaker:'Bruce',
          time:'6:17 AM',
          text:`Brad?`
        },
        {
          id:'elina-fixes-typo',
          direction:'received',
          speaker:'Elina',
          time:'6:21 AM',
          text:`Oops, meant Bruce, brain fart..`
        },
         {
          id:'brad-responds-to-her-rush-away',
          direction:'sent',
          speaker:'Bruce',
          time:'6:21 AM',
          text:`👍`
        },
      ]

    },


    {
      id: 'today',
      label: 'Today',
      messages: [
        {
          id: 'elina-breakup-message',
          direction: 'received',
          speaker: 'Elina',
          time: '1:25 PM',
          text: `Hey Bruce,

There's no easy way to say this so I'm just going to put it all down here and hope you can find it in your heart to forgive me.

I know it is cowardly to not do this in person, but I'm not ready for that just yet.

Being at my parent's place has given me time to think and reflect and I don't think this is working.

It's nothing that you've said or done. I just am not in a good place mentally to be maintaining a relationship at this point in time and need to focus on me.

I'm so sorry. You deserve to be happy and you deserve better.`,
        },
      ],
    },
  ],
})

/**
 * BEDROOM STORY TIMELINE
 *
 * This is the normal authoring file. Cues run from top to bottom.
 * - Camera/video/scene-event/transition/wait cues complete automatically.
 * - Dialogue waits for Space or a short screen click.
 * - Gameplay waits until game code calls completeGameplay(gameplayId).
 */
export const bedroomTimeline = {
  id: 'bedroom-opening',
  title: 'Bedroom · Opening Night',
  startsAfter: 'player-start',
  cues: [
    {
      id: 'unlock-browser-audio',
      type: 'audio',
      action: 'unlock',
      phase: 'starting',
      status: 'Unlocking audio',
    },
    {
      id: 'start-tv-show',
      type: 'video',
      action: 'play',
      source: assetUrl('videos/bedroom-tv-loop.mp4'),
      phase: 'intro',
      status: 'The show is playing',
    },
    {
      id: 'bedroom-background-music',
      type: 'audio',
      action: 'play-background',
      source: assetUrl('audio/vibehorn-sad-violin-music-478160.mp3'),
      options: { loop: true, volume: 0.003, fadeIn: 1.2 },
      notes: 'Loops continuously through the bedroom and kitchen chapters at 0.3% volume.',
    },
    {
      id: 'opening-camera-move',
      type: 'camera',
      action: 'play-intro',
      phase: 'intro',
      status: 'Opening scene',
    },
    {
      id: 'turn-off-tv',
      type: 'video',
      action: 'power-down',
      phase: 'tv-off',
      status: 'The room goes quiet',
    },
    {
      id: 'bruce-good-show',
      type: 'dialogue',
      line: {
        speaker: 'Bruce',
        text: "Oh, that was a good show. I'll watch it later tomorrow.",
      },
    },
    {
      id: 'bruce-bedtime-elina',
      type: 'dialogue',
      line: {
        speaker: 'Bruce',
        text: "It's time to sleep. Elina's been busy all day at her parents', I guess. She didn't even text me once today.",
      },
    },
    {
      id: 'elina-phone-beep',
      type: 'scene-event',
      event: 'phone-beep',
      text: 'Phone Beeped',
      durationMs: 1450,
      sound: 'phone-beep',
      vibrate: true,
      phase: 'notification',
      status: 'The phone beeped',
    },
    {
      id: 'bruce-text-message-reaction',
      type: 'dialogue',
      line: {
        speaker: 'Bruce',
        text: "Oh, it's Elina. A text message, huh? Could have called me instead. Anyway...",
      },
    },
    {
      id: 'open-elina-text-message',
      type: 'transition',
      effect: 'phone-focus',
      durationMs: 900,
      revealDurationMs: 520,
      phase: 'phone-transition',
      status: "Opening Elina's message",
    },
    {
      id: 'elina-phone-message-01-opening',
      type: 'dialogue',
      line: {
        source: 'phone-text',
        ...elinaPhoneConversation.openAt('elina-breakup-message', {
          initialPeekMessageId: 'elina-rushes-away',
        }),
      },
      notes: 'One complete text message; the player can scroll up to inspect earlier thread history.',
    },
    {
      id: 'bruce-breakup-reaction',
      type: 'phone-reaction',
      line: {
        speaker: 'Bruce',
        text: 'What the hell...? Seriously?',
      },
      phase: 'phone-reaction',
      status: 'Bruce reacts to the message',
    },
    {
      id: 'bruce-reply-delivery-fails',
      type: 'phone-reply',
      message: 'Wow... Just wow. 5 years and this is how you decide to end it?',
      deliveryError: 'Message delivery failed, could not reach the recepient.',
      errorSound: 'delivery-failed',
      typingIntervalMs: 62,
      typingProfile: 'emotional',
      typingSound: 'phone-key-tick',
      sendingDurationMs: 1200,
      phase: 'phone-reply',
      status: 'Bruce replies to Elina',
    },
    {
      id: 'bedroom-darkens-after-phone',
      type: 'lighting',
      action: 'fade',
      intensityScale: 0.025,
      durationMs: 2400,
      phase: 'lights-out',
      status: 'The room falls dark',
      notes: 'The phone is down; practical and ambient light collapse before the room changes.',
    },
    {
      id: 'swap-bedroom-to-kitchen',
      type: 'scene',
      action: 'swap',
      sceneId: 'kitchen',
      revealEffect: 'dots',
      revealDurationMs: 1150,
      phase: 'scene-transition',
      status: 'Moving to the kitchen table',
      notes: 'Bedroom resources are disposed under black, then the dots shrink off the kitchen.',
    },
    {
      id: 'next-morning-01-open-box',
      type: 'dialogue',
      line: {
        speaker: 'NEXT MORNING',
        kind: 'narration',
        text: 'Bruce is standing at the kitchen table gathering all the memories and gifts Elina gave him over the past 5 years.',
      },
      phase: 'next-morning',
      status: 'Bruce stands at the kitchen table',
    },
    {
      id: 'kitchen-camera-tour-step-01',
      type: 'camera',
      action: 'play-kitchen-tour-step',
      stepIndex: 0,
      keepDialogueVisible: true,
      phase: 'next-morning-camera',
      status: 'Looking into the box',
      notes: 'Space or click on the preceding narration releases this move to camera pose 2.',
    },
    {
      id: 'next-morning-02-gifts',
      type: 'dialogue',
      line: {
        speaker: 'NEXT MORNING',
        kind: 'narration',
        text: 'Bruce is putting it all in a box, a mug with a cheesy sentiment',
      },
      phase: 'next-morning',
      status: 'Gifts gathered over the years',
    },
    {
      id: 'kitchen-camera-tour-step-02',
      type: 'camera',
      action: 'play-kitchen-tour-step',
      stepIndex: 1,
      keepDialogueVisible: true,
      phase: 'next-morning-camera',
      status: 'Moving across the keepsakes',
      notes: 'Space or click on the mug narration releases this move to camera pose 3.',
    },
    {
      id: 'next-morning-02-gifts',
      type: 'dialogue',
      line: {
        speaker: 'NEXT MORNING',
        kind: 'narration',
        text: 'A memory book they made together with pictures and tales from that trip to California last year.',
      },
      phase: 'next-morning',
      status: 'Gifts gathered over the years',
    },
    {
      id: 'kitchen-camera-tour-step-03',
      type: 'camera',
      action: 'play-kitchen-tour-step',
      stepIndex: 2,
      keepDialogueVisible: true,
      phase: 'next-morning-camera',
      status: 'Moving toward the memory book',
      notes: 'Space or click on the memory-book narration releases this move to camera pose 4.',
    },
    {
      id: 'next-morning-03-california',
      type: 'dialogue',
      line: {
        speaker: 'NEXT MORNING',
        kind: 'narration',
        text: 'A sweater she said would look good on him when they walk together, a perl necklace, scarf and other gifts.',
      },
      phase: 'next-morning',
      status: 'Memories from California',
    },
    {
      id: 'kitchen-camera-tour-step-04',
      type: 'camera',
      action: 'play-kitchen-tour-step',
      stepIndex: 3,
      keepDialogueVisible: true,
      phase: 'next-morning-camera',
      status: 'Pulling back from the table',
      notes: 'Space or click on the preceding narration releases this move to camera pose 5.',
    },
    {
      id: 'next-morning-04-sealing-box',
      type: 'dialogue',
      line: {
        speaker: 'NEXT MORNING',
        kind: 'narration',
        text: 'He is putting the last couple of items into the box, about to seal it while talking to himself.',
      },
      phase: 'next-morning',
      status: 'Bruce prepares to seal the box',
      notes: 'The camera remains at pose 5 after this final narration card advances.',
    },
    {
      id: 'kitchen-table-packed-transition',
      type: 'scene-state',
      action: 'set-kitchen-packed',
      effect: 'dots',
      durationMs: 950,
      revealDurationMs: 950,
      phase: 'packed-table-transition',
      status: 'The box has been packed',
      notes: 'Final Space/click expands black dots, swaps table groups and applies packed-file transforms under cover, then reveals the closed box and car key while the packed camera shot plays for three seconds.',
    },
    {
      id: 'bruce-blindsided-after-packing',
      type: 'dialogue',
      line: {
        speaker: 'Bruce',
        text: 'I can\'t believe she blindsided me like that. She takes one trip to her parent\'s without me and suddenly "that\'s it. See ya!"',
      },
      phase: 'packed-table-dialogue',
      status: 'Bruce processes the breakup',
    },
    {
      id: 'bruce-return-the-gifts',
      type: 'dialogue',
      line: {
        speaker: 'Bruce',
        text: 'Seriously? I can\'t even stand to look at this stuff right now. Better if I just give it all back.',
      },
      phase: 'packed-table-dialogue',
      status: 'Bruce decides to return the gifts',
      notes: 'Performance direction only (not shown visually): Bruce sighs heavily before this line.',
    },
    {
      id: 'stop-bedroom-kitchen-background-music',
      type: 'audio',
      action: 'stop-background',
      fadeOut: 0.8,
      phase: 'scene-transition',
      status: 'Leaving the kitchen',
      notes: 'Ends the bedroom/kitchen violin loop before the exterior is revealed.',
    },
    {
      id: 'elina-exterior-background-music',
      type: 'audio',
      action: 'play-background',
      source: assetUrl('audio/idoberg-relaxing-guitar-loop-v5-245859.mp3'),
      options: { loop: true, volume: 0.005, fadeIn: 0.8 },
      phase: 'scene-transition',
      status: 'Arriving at Elina\'s place',
      notes: 'Starts beneath the transition so the relaxing guitar is present for the exterior from its first visible frame, looping at 0.5% volume.',
    },
    {
      id: 'swap-kitchen-to-elina-exterior',
      type: 'scene',
      action: 'swap',
      sceneId: 'exterior',
      revealEffect: 'dots',
      coverDurationMs: 1000,
      revealDurationMs: 1100,
      phase: 'scene-transition',
      status: 'Arriving outside Elina\'s house',
      notes: 'Dots visibly expand over the packed kitchen, kitchen resources are disposed under black, and the clean exterior is revealed during its configured camera-arrival move with unrestricted authoring controls.',
    },
    {
      id: 'elina-place-arrival-narration',
      type: 'dialogue',
      line: {
        speaker: 'ELINA\'S PLACE',
        kind: 'narration',
        text: 'Bruce arrived at Elina\'s place, puts down the packed gifts and memories and was about to leave, but..',
      },
      phase: 'exterior-arrival',
      status: 'Bruce leaves the packed memories at Elina\'s place',
    },
    {
      id: 'bruce-remembers-elinas-spare-key',
      type: 'dialogue',
      line: {
        speaker: 'Bruce',
        text: 'Wait, she\'s at her parents and nobody\'s home. Huh. She keeps her key under the doormat I remember.',
      },
      phase: 'exterior-arrival',
      status: 'Bruce remembers where Elina keeps her spare key',
    },
    {
      id: 'check-elinas-doormat',
      type: 'gameplay',
      gameplayId: 'check-elinas-doormat',
      title: 'Look for the key',
      instructions: 'Check beneath the doormat.',
      tutorial: {
        title: 'Explore the porch',
        instructions: [
          'Drag up, down, left, or right to explore.',
          'Click objects to look for the key.',
        ],
        confirmLabel: 'Got it',
      },
      progressText: 'No key beneath the doormat.',
      phase: 'exterior-objective',
      status: 'Check beneath the doormat',
      notes: 'The doormat slides toward the door and reveals an empty patch of porch.',
    },
    {
      id: 'pause-on-empty-doormat',
      type: 'wait',
      durationMs: 1500,
      phase: 'exterior-reaction',
      status: 'The empty hiding place remains visible',
      notes: 'Keeps the cleared doormat readable for a beat before Bruce\'s dialogue card appears.',
    },
    {
      id: 'bruce-realizes-key-was-moved',
      type: 'dialogue',
      line: {
        speaker: 'Bruce',
        text: 'Wow... she planned it a week ago ? to dump me ? and hid it somewhere else ? Huh.',
      },
      phase: 'exterior-reaction',
      status: 'The spare key is not beneath the doormat',
    },
    {
      id: 'bruce-vows-to-get-inside',
      type: 'dialogue',
      line: {
        speaker: 'Bruce',
        text: 'I\'ll either find the key or break in no matter what...',
      },
      phase: 'exterior-reaction',
      status: 'Bruce keeps searching for another way inside',
    },
    {
      id: 'find-elinas-spare-key',
      type: 'gameplay',
      gameplayId: 'find-elinas-spare-key',
      title: 'Look for the key',
      instructions: 'Click objects around the porch to find the key.',
      missFeedback: 'Not here...',
      hint: {
        afterMisses: 10,
        text: 'Hint: Try that broken pot.',
      },
      completesObjective: true,
      phase: 'exterior-objective',
      status: 'Search the porch for Elina\'s spare key',
      notes: 'Clicking the broken pot moves it aside and leaves the authored hidden key visible through Bruce\'s next line.',
    },
    {
      id: 'bruce-finds-elinas-spare-key',
      type: 'dialogue',
      line: {
        speaker: 'Bruce',
        text: 'There you are… Guess you didn\'t hide it well enough. Now, let\'s see what you were trying to keep me out of.',
      },
      phase: 'exterior-key-found',
      status: 'Bruce finds Elina\'s spare key',
      notes: 'The broken pot remains aside and the key remains under it until this line is advanced.',
    },
    {
      id: 'collect-elinas-spare-key',
      type: 'exterior-action',
      action: 'collect-door-key',
      phase: 'exterior-key-pickup',
      status: 'Picking up the spare key',
      notes: 'The key moves calmly to camera, docks into its achievement circle, and the broken pot returns home.',
    },
    {
      id: 'pause-before-entering-elinas-house',
      type: 'wait',
      durationMs: 1000,
      phase: 'exterior-entry',
      status: 'The porch settles',
    },
    {
      id: 'prompt-enter-elinas-house',
      type: 'action-prompt',
      action: 'enter-elinas-house',
      label: 'Now, let’s get inside 😈',
      phase: 'exterior-entry',
      status: 'Ready to enter Elina\'s house',
    },
    {
      id: 'cover-exterior-for-elina-interior',
      type: 'transition',
      effect: 'dots',
      durationMs: 1050,
      holdOnBlack: true,
      destination: 'elina-interior',
      phase: 'scene-transition',
      status: 'Entering Elina\'s house',
      notes: 'The exterior is disposed under black. The future interior scene should be installed here, then call revealDots to continue.',
    },
    {
      id: 'stop-elina-exterior-background-music',
      type: 'audio',
      action: 'stop-background',
      fadeOut: 0.6,
      phase: 'scene-transition',
      status: 'Exterior music ended',
      notes: 'Stops and releases the guitar loop only after the exterior has been fully covered and disposed.',
    },
  ],
} satisfies SceneTimeline
